var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheveronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292568 0.959641C-0.0979567 1.35016 -0.0979568 1.98333 0.292568 2.37385L4.91879 7.00008L0.292567 11.6263C-0.0979576 12.0168 -0.0979577 12.65 0.292567 13.0405C0.683091 13.431 1.31626 13.431 1.70678 13.0405L7.04011 7.70719C7.43064 7.31667 7.43064 6.6835 7.04011 6.29297L1.70678 0.959641C1.31626 0.569116 0.683092 0.569116 0.292568 0.959641Z",
    fill: "url(#paint0_linear_10714_28374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10714_28374",
    x1: 7.33301,
    y1: 0.666748,
    x2: -1.64557,
    y2: 1.96628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9079FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveronLeft);
export default __webpack_public_path__ + "static/media/cheveron-left.13156531a3c15a65b789972b69116ee4.svg";
export { ForwardRef as ReactComponent };